import React from 'react';
import ProfileMenu from './ProfileMenu';
import { connect } from 'react-redux';
import { languages, languageOptions, getSelectedLanguage, setSelectedLanguage } from '../languages';

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = { theme: localStorage.getItem('avaliador_theme') || 'light', selectedLanguage: getSelectedLanguage() };
    }

    componentDidMount() {
        document.body.classList.toggle('avaliador-dark-theme', this.state.theme == 'dark');
        this.languageListener = () => this.setState({ selectedLanguage: getSelectedLanguage() });
        window.addEventListener('avaliador_language_change', this.languageListener);
    }

    componentWillUnmount() { if (this.languageListener) window.removeEventListener('avaliador_language_change', this.languageListener); }

    toggleTheme() {
        let theme = this.state.theme == 'dark' ? 'light' : 'dark';
        localStorage.setItem('avaliador_theme', theme);
        document.body.classList.toggle('avaliador-dark-theme', theme == 'dark');
        this.setState({ theme });
    }

    changeLanguage(event) {
        let selectedLanguage = setSelectedLanguage(event.target.value);
        this.setState({ selectedLanguage });
    }

    render() {
        let t = languages[this.state.selectedLanguage] || languages.Pt;
        let logoSrc = this.props.faculdade.logo;
        return (
            <div className="topbar avaliador-app-header" id="header_page" style={{ position: this.props.sala_screen == true ? 'absolute' : 'fixed' }}>
                <div className="topbar-left avaliador-header-brand">
                    {this.props.faculdade.logo != null && <a className="logo avaliador-header-logo"><span><img src={logoSrc} alt="" height="70" /></span><i><img className="img-fluid" src={logoSrc} alt="" style={{ height: 70, objectFit: 'contain' }} /></i></a>}
                </div>
                <nav className="navbar-custom avaliador-header-nav">
                    <ul className="navbar-right avaliador-header-actions d-flex list-inline float-right mb-0">
                        <li className="list-inline-item"><button type="button" className="avaliador-preference-theme-button compact" onClick={this.toggleTheme.bind(this)}><i className={this.state.theme == 'dark' ? 'mdi mdi-white-balance-sunny' : 'mdi mdi-weather-night'}></i><span>{this.state.theme == 'dark' ? t.theme_light : t.theme_dark}</span></button></li>
                        <li className="list-inline-item"><label className="avaliador-preference-select compact" data-language-label={this.state.selectedLanguage}><i className="mdi mdi-web"></i><select value={this.state.selectedLanguage} onChange={this.changeLanguage.bind(this)} aria-label={t.language_label} title={t.language_label}>{languageOptions.map((item) => <option key={item.value} value={item.value}>{item.value}</option>)}</select></label></li>
                        <ProfileMenu t={t} />
                    </ul>
                </nav>
            </div>
        );
    }
}
const mapsStateToProps = (state) => ({ faculdade: state.AppReducer.faculdade, sala_screen: state.AppReducer.sala_screen });
export default connect(mapsStateToProps, {})(Header);
